module.exports = __webpack_public_path__ + "static/scale-model-of-neptune-statue-in-virginia-beach-virginia-61ddadae0013fb23955381097e29bc1f.png";